/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { getIn, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import CreditCardImage from 'common/components/creditCard/CreditCardImage';
// eslint-disable-next-line import/no-cycle
import {
  normalizeCreditCard,
  getCreditCardBrand
} from 'common/components/forms';

import FormError from './common/FormError';

const CreditCardInput = (props) => {
  const {
    field,
    form,
    label,
    required = false,
    maxLength,
    displayErrors = true,
    describedByLabel,
    describedByContent,
    autoFocus
  } = props;

  const { name, value, onChange: onFieldChange } = field;
  const id = `c7-${name}`;

  const formikContext = useFormikContext();
  const { setFieldValue, values } = formikContext;

  const { touched, errors } = form;

  useEffect(() => {
    setFieldValue(
      'creditCardNumber',
      normalizeCreditCard(String(value), value, values),
      false
    );
  }, []); // eslint-disable-line

  const handleOnChange = (e) => {
    let newEvent = e;

    const newValue = normalizeCreditCard(e.target.value, value, values);
    newEvent = { target: { value: newValue, id: name, name } };

    return onFieldChange(newEvent);
  };

  const error = getIn(errors, name);
  const touch = getIn(touched, name);

  const labelId = `${id}-label`;
  const errorId = `${id}-error`;

  let ariaDescribedBy;
  if (describedByLabel) {
    ariaDescribedBy = describedByLabel;
  }
  if (touch && error) {
    ariaDescribedBy = errorId;
  }

  const cardBrand = getCreditCardBrand(value);

  return (
    <div className="c7-form__field c7-form--card-number">
      <label
        htmlFor={id}
        id={labelId}
        className={classNames(required && 'c7-required')}
      >
        {label}
      </label>
      <input
        {...field}
        onChange={handleOnChange}
        type="text"
        required={required}
        aria-required={required}
        name={name}
        id={id}
        aria-labelledby={labelId}
        autoComplete="cc-number"
        placeholder="1234 1234 1234 1234"
        maxLength={maxLength}
        inputMode="numeric"
        aria-invalid={!!error && touch}
        aria-describedby={ariaDescribedBy}
        /* TODO Andrea - autofocus and usability */
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
      />
      <CreditCardImage cardBrand={cardBrand} />
      {describedByContent}
      {displayErrors && (
        <FormError touch={touch} error={error} id={errorId} label={label} />
      )}
    </div>
  );
};

export default CreditCardInput;
